export default __webpack_public_path__ + "static/media/DSC_7540.f1bef31c.jpg";